import { EntityLabel } from '@esg/esg-global-types';

// Singular and plural label for model entity.
export const export_label: EntityLabel = {
  one: 'Export',
  many: 'Exports'
};

// Singular and plural label for export types.
export const export_type_label: EntityLabel = {
  one: 'Export Type',
  many: 'Export Types'
};
